import axios from "axios";
import { APICore } from "./apiCore";

const api = new APICore();

// course
function addNews(params: { title_en: string; title_ar: string; description_en: string; coverimage: any; description_ar: string }) {
  const baseUrl = "/news";
  return api.createWithFile(`${baseUrl}`, params);
}

function getNews() {
  const baseUrl = "/news";
  return api.get(`${baseUrl}`, {});
}

function updateNews(
  id: number,
  params: {
    title_en: string;
    title_ar: string;
    description_en: string;
    description_ar: string;
    coverimage: any;
  }
) {
  const baseUrl = `/news/${id}`;
  return api.updateWithFile(`${baseUrl}`, params);
}

function deleteNews(id: number) {
  const baseUrl = `/news/${id}`;
  return api.delete(`${baseUrl}`);
}

function deleteNewsImageApi(ids: string[]) {
  const result = axios.delete(`/newsImage`, { data: { ids } });
  return result;
}

function addNewsBannerApi(params: { file: any; banner_text: string; banner_text_ar: string }) {
  const baseUrl = "/news-image";
  return api.createWithFile(`${baseUrl}`, params);
}

function getNewsBannerApi() {
  const baseUrl = "/news-image";
  return api.get(`${baseUrl}`, {});
}

function updateNewsBannerApi(
  id: number,
  params: {
    file: any;
    banner_text: string;
    banner_text_ar: string;
  }
) {
  const baseUrl = `/news-image/${id}`;
  return api.updateWithFile(`${baseUrl}`, params);
}

function deleteNewsBannerApi(id: number) {
  const baseUrl = `/news-image/${id}`;
  return api.delete(`${baseUrl}`);
}

export { addNews, deleteNews, getNews, updateNews, deleteNewsImageApi, addNewsBannerApi, getNewsBannerApi, updateNewsBannerApi, deleteNewsBannerApi };
